<script>
    export let featLayout;
    export let selectedTabIdx;
</script>

<style>
    .tab-track {
        display: flex;
        align-items: flex-start;
        margin-left: 0.5rem;
    }
    .tab {
        text-transform: uppercase;
        margin: 0;
        letter-spacing: 0.05em;
        cursor: pointer;
        height: 5rem;
        margin-bottom: -2.5rem;
    }

    div.tab:nth-child(1) {
        z-index: 1;
    }

    div.tab:nth-child(2) {
        margin-left: -2.5rem;
        padding-left: 2.5rem;
        margin-left: -2rem;
    }

    .selected {
        font-weight: bold;
    }

</style>

<div class="tab-track">
    {#each featLayout as section, i}
        <div class="tab box lev1"
            class:dark="{selectedTabIdx == i}"
            class:light="{selectedTabIdx != i}"
            class:selected="{selectedTabIdx == i}"
            on:click={() => {selectedTabIdx = i}}
            role="button" title="{section[0]}">{section[0]}</div>
    {/each}
</div>